import type { ActionContext } from 'vuex'

import type { ActionClass, AppState } from '../../../models'

import { APP_CONSTS } from '../app.consts'

export class SetFiltersHiddenAction implements ActionClass {
  static execute(
    this: void,
    { commit }: ActionContext<AppState, any>,
    filtersHidden: boolean,
  ): void {
    commit(APP_CONSTS.mutations.setFiltersHidden, filtersHidden)
  }
}
